<template>
  <div>
    <ul class="pager" v-if="currentPage !== pageTotal">
      <li>
        <button
          class="prev vanilla-module ATM01-button ATM01-button--primary ATM01-button--medium"
          :class="{'btn-hidden' : isDisabled('prev')}"
          :disabled="isDisabled('prev')"
          @click="stepping(false)">
            <span class="ATM01-button__icon">
              <span class="ATM01-button__canvas">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                </svg>
              </span>
            </span>
            <span class="ATM01-button__label">{{ prevText }}</span>
          </button>
      </li>
      <li>
        <button
          id="solution-builder-next"
          :data-progress="currentPage + ' out of ' + pageTotal"
          class="next vanilla-module ATM01-button ATM01-button--primary ATM01-button--medium"
          :class="[{'ATM01-button--disabled' : isDisabled('next')}, {'btn-rounded': isDisabled('prev')}]"
          :disabled="isDisabled('next')"
          @click="stepping(true)">
          <span class="ATM01-button__label">{{ nextText }}</span>
          <span class="ATM01-button__icon">
            <span class="ATM01-button__canvas">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </span>
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "Pager",
  props: ['pageTotal', 'currentPage', 'prevText', 'nextText'],
  data() {
    return {
      step: 0,
    }
  },
  methods: {
    stepping(forward) {
      if (this.currentPage === (this.pageTotal - 1) && forward) {
        this.$emit('stepped', forward);
      } else {
        this.$emit('stepped', forward);
      }
    },
    isDisabled(type) {
      // Disabling on last page
      if (this.currentPage >= this.pageTotal && type === 'next') {
        return true;
      } else if (this.currentPage <= 1 && type === 'prev') {
        return true;
      } else {
        return false;
      }
    },
  },
}

</script>

<style scoped>
  #loading:not(.hidden) {
    opacity: 1;
    transition: opacity 0.3ms ease;
  }

  .pager {
    list-style: none;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .pager > li {
    display: inline-block;
    margin-top: 2rem;
  }

  button {
    cursor: pointer;
  }
  button[disabled] {
    cursor: not-allowed;
  }


  .btn-hidden {
    display: none;
  }

  svg {
    inline-size: 20px;
    block-size: 20px;
  }
</style>